// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".divider[data-v-7d5d3f4e]{background:linear-gradient(90deg,#4a2075 45%,#ff6700,#fd0)!important;max-height:none!important;height:4px!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
